var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.74723V2.29347C0 1.02862 1.0476 0 2.33579 0H3.50369C3.77464 0 4.0456 0.0624969 4.28735 0.181184L6.12971 1.08596C6.21029 1.12552 6.30081 1.14616 6.39073 1.14616H9.34318C10.9531 1.14616 12.2629 2.43222 12.2629 4.01299H5.8535C4.31304 4.01299 2.93201 5.02556 2.49346 6.48019L0.932566 11.8349C0.362048 11.3114 0 10.5723 0 9.74723ZM13.7187 5.74341C13.439 5.37474 13.0127 5.16317 12.5461 5.15571C12.5374 5.15571 12.5304 5.1603 12.5216 5.1603H5.8535C4.82692 5.1603 3.90603 5.83515 3.61464 6.80127L1.96907 12.4449C2.26864 12.547 2.58514 12.6141 2.91974 12.6141H10.253C11.5528 12.6141 12.6764 11.793 13.0571 10.5459L13.9517 7.03922C14.0883 6.59085 14.0031 6.11897 13.7187 5.74341Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.58d97e25d6ea0622a1ecd8a13a2bba1d.svg";
export { ForwardRef as ReactComponent };